
const MissionSection = () => {
  return (
    <section className="py-20" style={{ backgroundColor: '#F8F4EF' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          <h2 
            className="text-4xl lg:text-5xl font-bold mb-8"
            style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
          >
            Our Mission
          </h2>
          
          <div className="space-y-6">
            <p 
              className="text-xl lg:text-2xl leading-relaxed"
              style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}
            >
              We believe work should feel clear, steady, and human — not cluttered by busywork and constant follow-up.
            </p>
            
            <p 
              className="text-xl lg:text-2xl leading-relaxed"
              style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}
            >
              Our mission is to help organizations move out of survival mode and into stability by replacing manual processes with seamless systems that support your team, your time, and your goals.
            </p>
            
            <p 
              className="text-xl lg:text-2xl leading-relaxed font-semibold"
              style={{ color: '#7B6655', fontFamily: 'Inter, sans-serif' }}
            >
              When operations run smoothly, your people can focus on what actually matters.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
